import React, { useEffect, useState } from "react";
import { getTop5PerformingApps } from "service/analytics.service";


const Top5PerformingOffers = () => {
  const [analyticsData, setAnalyticsData] = useState([]);

  useEffect(() => {
    // Fetch the analytics data from the API endpoint
    getTop5PerformingOffersForDashboard();
  }, []);

  const getTop5PerformingOffersForDashboard = async () => {

    try {
      const analytics = await getTop5PerformingApps();
      console.log(analytics);
      setAnalyticsData(analytics.data.top5Feed);
    //   setAnalytics(analytics.data);
    //   setOfferTypeData(offertype.data.offerTypeFeed);
    // setChartData(analytics.data.lineGraphData );
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }
  
  
  };

  return (
  
    <><div className="card-header pb-0 p-3">
          <h6 className="mb-0">Top 5 Conversations</h6>
      </div><div className="card-body p-3">
              <ul className="list-group">
              {analyticsData.map((item) => (
                  <li className="list-group-item border-0 d-flex align-items-center px-0 mb-2">
                      <div className="avatar me-3" style={{borderRadius: '20%'}}>
                          <img
                              src={item.offer.offer_small_icon}
                              alt="offer icon"
                              className="border-radius-lg shadow" />
                      </div>
                      <div className="d-flex align-items-start flex-column justify-content-center">
                          <h6 className="mb-0 text-sm">{item.offer.offer_name}</h6>
                          <p className="mb-0 text-xs"></p>
                      </div>
                      <a className="btn btn-link pe-3 ps-0 mb-0 ms-auto" href="javascript:;">
                          {item.conversionRate}%
                      </a>
                  </li>
              ))}
              </ul>
          </div></>

  
  );
};

export default Top5PerformingOffers;
